import Vue from 'vue'

import FileUploadAsBSF from 'vue-file-upload-as-bsf'

Vue.component('vue-file-upload-as-bsf', FileUploadAsBSF)
